export const NOTIFICATION_TYPES = [
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_CREATED',
    value: 'conversation_creation',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_ASSIGNED',
    value: 'conversation_assignment',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_MENTION',
    value: 'conversation_mention',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.ASSIGNED_CONVERSATION_NEW_MESSAGE',
    value: 'assigned_conversation_new_message',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.PARTICIPATING_CONVERSATION_NEW_MESSAGE',
    value: 'participating_conversation_new_message',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.CONVERSATION_LABEL',
    value: 'conversation_label',
  },
  {
    label:
      'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_FIRST_RESPONSE',
    value: 'sla_missed_first_response',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_NEXT_RESPONSE',
    value: 'sla_missed_next_response',
  },
  {
    label: 'PROFILE_SETTINGS.FORM.NOTIFICATIONS.TYPES.SLA_MISSED_RESOLUTION',
    value: 'sla_missed_resolution',
  },
];

export const EVENT_TYPES = {
  ASSIGNED: 'assigned',
  NOTME: 'notme',
  UNASSIGNED: 'unassigned',
};

export const ALERT_EVENTS = [
  {
    value: EVENT_TYPES.ASSIGNED,
    label: 'assigned',
  },
  {
    value: EVENT_TYPES.UNASSIGNED,
    label: 'unassigned',
  },
  {
    value: EVENT_TYPES.NOTME,
    label: 'notme',
  },
];

// Tones served from /audio/dashboard/<value>.mp3, grouped by theme in the
// profile selector. Modern, retro and RPG tones are synthesized locally by
// script/generate_alert_tones.py; retro and RPG are original motifs and must not
// reference existing games. Messages, confirmation and melodic tones come from
// Mixkit (script/import_mixkit_alert_tones.py, credits in
// public/audio/dashboard/CREDITS.md).
export const DEFAULT_ALERT_TONE = 'ding';
export const ALERT_TONE_GROUPS = [
  {
    key: 'MESSAGES',
    tones: ['msg_pop', 'msg_bubble', 'msg_dry_pop', 'msg_fairy', 'msg_hint'],
  },
  {
    key: 'CONFIRMATION',
    tones: ['tone_confirm', 'tone_digital', 'tone_positive', 'tone_elevator'],
  },
  {
    key: 'MELODIC',
    tones: [
      'mel_bell',
      'mel_happy_bells',
      'mel_magic_ring',
      'mel_guitar',
      'mel_flute',
      'mel_doorbell',
    ],
  },
  {
    key: 'CLASSIC',
    tones: [
      'ding',
      'bell',
      'chime',
      'magic',
      'ping',
      'soft',
      'crystal',
      'double',
      'ringtone',
      'drumroll',
    ],
  },
  {
    key: 'MODERN',
    tones: [
      'drop',
      'pop',
      'marimba',
      'digital',
      'harp',
      'ding_dong',
      'glass',
      'rise',
      'knock',
    ],
  },
  {
    key: 'RETRO',
    tones: [
      'retro_coin',
      'retro_powerup',
      'retro_jump',
      'retro_extra_life',
      'retro_item',
      'retro_menu',
      'retro_laser',
      'retro_lose',
      'retro_blip',
    ],
  },
  {
    key: 'RPG',
    tones: [
      'rpg_quest',
      'rpg_treasure',
      'rpg_level_up',
      'rpg_scroll',
      'rpg_potion',
      'rpg_crystal',
    ],
  },
];
export const ALERT_TONES = ALERT_TONE_GROUPS.flatMap(group => group.tones);
export const alertToneUrl = tone => `/audio/dashboard/${tone}.mp3`;
